import { useTranslation } from "react-i18next";

export const getGuidancePrefixForType = (surveyType: string) => {
  return `survey.guidancePage.${surveyType.toLowerCase()}`;
};

export const getGuidanceTranslator = (surveyType: string) => {
  const { t } = useTranslation();
  const prefix = getGuidancePrefixForType(surveyType);

  return (key: string) => t(`${prefix}.${key}`);
};
